<script lang="ts" setup>
import Page from "./default-page.vue";
</script>

<template>
  <Page layout="error">
    <h1>Pagina niet gevonden!</h1>
    <section class="pt-4">
      Klik
      <router-link to="/" class="text-blue-500 underline hover:no-underline"
        >hier</router-link
      >
      om terug te gaan naar de homepage.
    </section>
  </Page>
</template>
